import React from "react";
import styled from "styled-components";

const AboutContainer = styled.div`
    margin: 0 auto;
    max-width: 820px;
    padding: 40px;
    text-align: justify;
    font-size: 15px;
    background-color: #ffffff;
    color: black;

    p {
      padding-bottom: 20px;
    }

    a {
      color: black;
      text-decoration: underline; 
    }

    @media (max-height: 500px) {
      width: 80%;
      padding: 0px;
       p {
        padding-bottom: 5px;
       }
    }

    @media (max-height: 375px) {
      width: 80%;
      padding: 0px;
       p {
        padding-bottom: 1px;
       }
    }
`

function About(props) {
  return (
    <AboutContainer onClick={() => props.openNavbar(false)}>
      <h2 id="about">About</h2>
      <p>
        This website is an interactive map of the Manchester Metrolink network.
      </p>

      <p>
        Despite living in Manchester (almost) my whole life I still find myself 
        struggling to check which line I can catch to get to my destination.
        I created this website to help myself and others. 
      </p>

      <p>
        Clicking on a tram stop or its label shows up-to-date travel alerts for that stop or line.<br/>
        Additional information about the tram stop is taken from its Wikipedia entry.
      </p>

      <p>
        The map is movable by dragging 👋 and scalable by zooming 🔍.
      </p>

      <p>
        The design was inspired by <a
          href="https://ubahn-map.com"
          data-umami-event="External link clicked"
          data-umami-event-destination="ubahn-map.com"
        >
          Ubahn-Map
        </a> and
        was built using a modified version of the <a
          href="https://observablehq.com/@johnwalley/d3-tube-map"
          data-umami-event="External link clicked"
          data-umami-event-destination="observablehq.com"
        >
          d3-tube-map
        </a> library.
      </p>

      <p>
        This website is <b>not affiliated</b> with TFGM(Transport for Greater Manchester) and for accurate and up-to-date
        information regarding the Metrolink network please visit <a
          href="https://tfgm.com/"
          data-umami-event="External link clicked"
          data-umami-event-destination="tfgm.com"
        >
          TFGM
        </a>.
      </p>
    </AboutContainer>
  );
}

export default About;